import MapSVG from "@design-system/ui-icons/vanilla/Map"
import { createIcon } from "../createIcon"

export const MapIcon = createIcon(MapSVG)
